<template>
  <div class="systemitem">
    <span>{{ title }}：</span>
    <div class="input-select">
      <slot v-if="slots" :name="slots"></slot>
      <el-input v-else v-model="inputcv" clearable placeholder="请输入内容" size="medium"
                @change="handleChange"></el-input>
    </div>
    <div v-if="etitle === 'button' || etitle === 'date'">&ensp;&ensp;&ensp;&ensp;</div>

    <el-button type="text" plain @click="handleSetContent" v-else>设置
    </el-button>
    <p>{{ content }}</p>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    set: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    etitle: {
      type: String,
      default: ''
    },
    slots: {
      type: String,
      default: ''
    },
    inputc: {},
    content: {
      type: String,
      default: ''
    },
  },
  computed: {
    inputcv: {
      get() {
        return this.inputc
      },
      set(val) {
        this.$emit('update:inputc', val)
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    handleChange(val) {
      this.$emit('update:inputc', val)
    },
    handleSetContent() {
      if (this.set == 'theme') {
        this.$emit('handleSetContent')
      } else if (this.set == 'cloud' && this.etitle == 'listen' || this.set == 'cloud' && this.etitle == 'port' || this.set == 'mqtt' && this.etitle == 'port' || this.set == 'mqtt' && this.etitle == 'keepalive') {
        this.$emit('handleSetContent', {node: this.set, key: this.etitle, value: Number(this.inputcv)})
      } else {
        this.$emit('handleSetContent', {node: this.set, key: this.etitle, value: this.inputcv})
      }
    }
  }
}
</script>

<style lang="less" scoped>
.systemitem {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0px;
  }

  span {
    display: inline-block;
    width: 120px;
    text-align: right;
    flex-shrink: 0;
    margin-right: 3px;
  }

  .input-select {
    width: 200px;
    margin-right: 20px;
    flex-shrink: 0;
  }

  ::v-deep .el-input {
    width: 200px;
    flex-shrink: 0;

    .el-input__inner {
      font-size: 12px;
    }
  }

  .el-button {
    font-size: 12px;
    border: none;
    color: #1677ff;
  }

  p {
    color: #99A0A9;
    margin-left: 20px;
  }
}
</style>